import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import './tooltip.scss';

@Component({
  template: `
<div class="tooltip top">
  <div class="tooltip--container">
    <div class="tooltip--text">
      <slot></slot>
    </div>
    <div class="tooltip--tip"></div>
  </div>
</div>
`
})
export class TooltipComponent extends Vue {

}

Vue.component('tooltip', TooltipComponent);



// WEBPACK FOOTER //
// ./src/components/tooltip/tooltip.ts